import { GetterTree } from 'vuex'
import { WidgetState } from "@/apps/StudentExchangeOverviewWidget/models/store-viewmodel"
import { ILabels, ILanguage } from "@/apps/StudentExchangeOverviewWidget/models/config-viewmodel";
import { IStudies, IStudy } from "@/apps/StudentExchangeOverviewWidget/models/studies-viewmodel";
import {
    IAdmission,
    IAdmissions,
    IUniqueAdmissions
} from "@/apps/StudentExchangeOverviewWidget/models/admissions-viewmodel";
import { IExchangeYear, IExchangeYears } from "@/apps/StudentExchangeOverviewWidget/models/exchanges-viewmodel"

export default <GetterTree<WidgetState, WidgetState>>{
    getLoading(state): boolean {
        return state.loading
    },
    getLabels(state): ILabels {
        return state.labels
    },
    getLanguage(state): ILanguage {
        return state.language
    },
    getStudies(state): IStudies {
        return state.studies.sort((a, b) => Number(b.academicYearId) - Number(a.academicYearId));
    },
    getSelectedFilterYear(state): string {
        return state.selectedFilterYear
    },
    getSelectedFilterStudy(state): string {
        return state.selectedFilterStudy
    },
    getExchangeYears(state, getters): IExchangeYears {
        return getters.getStudies.map((study: IStudy) => {
            return {
                academicYearId: study.academicYearId,
                academicYear: study.academicYear
            }
        })
    },
    getUniqueAdmissions(state, getters): IUniqueAdmissions {
        let admissions: IAdmissions = []
        getters.getStudies.forEach((study: IStudy) => {
            if (study.admissions?.length) {
                admissions = [...admissions, ...study.admissions]
            }
        })
        // deduplicate admissions
        return admissions.filter((value: IAdmission, index: number, self: IAdmissions) => {
            return index === self.findIndex((admission: IAdmission) => (
                admission.programOfStudyId === value.programOfStudyId
            ))
        })
    },
    getModalOpen(state): Boolean {
        return state.isModalOpen
    },
    getOffset(state): number {
        return state.offset
    }
}
